import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

import { cn, customImageLoader, getAssetSrc } from '@restworld/utils-common';
import { Tooltip, Button as ButtonV2, IconComponentType } from '@restworld/ui-ds-base';

function ShowcaseInfoCard({ button, content, image, isOffline }: ShowcaseInfoCardProps) {
  const { t } = useTranslation('restaurant-details-page');

  const ctaEl = useMemo(
    () => (
      <ButtonV2
        StartIcon={button.Icon}
        className={'text-sm min-h-[32px] h-8 lg:text-base lg:min-h-[48px] lg:h-12'}
        fullwidth
        onClick={button.onClick}
        loading={button.loading}
        disabled={isOffline}
      >
        {button.text}
      </ButtonV2>
    ),
    [button.Icon, button.loading, button.onClick, button.text, isOffline]
  );

  return (
    <Wrapper>
      <div className=" flex flex-col gap-4">
        <div className="w-8 h-8 relative lg:w-14 lg:h-14">
          <Image src={getAssetSrc(image)} loader={customImageLoader} alt="" fill />
        </div>
        {/* <Title fontSize="base" textColor="neutral-700" fontWeight="medium">
          {title}
        </Title> */}
        <p className="text-neutral-700 text-base">{content}</p>
      </div>
      {isOffline ? (
        <Tooltip content={t('publish_your_showcase_to_get_access_to_this_feature')} placement="bottom">
          {ctaEl}
        </Tooltip>
      ) : (
        ctaEl
      )}
    </Wrapper>
  );
}
export default ShowcaseInfoCard;

interface ShowcaseInfoCardProps {
  image: string;
  content: string;
  button: { text: string; onClick?: () => void; Icon: IconComponentType; loading?: boolean };
  isOffline?: boolean;
}

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'p-6 pt-8 rounded-2xl bg-purple-50 border border-purple-700 flex flex-col gap-4 flex-1 md:justify-between lg:justify-start',
      className
    )}
    {...props}
  />
);
